import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import SelectItem from "../../elems/Select";

const customStyles = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: 'white',
    borderColor: state.isFocused ? '#404ff5' : '#e9eaf5',
    boxShadow: state.isFocused ? '0px 0px 20px #404FF54D' : 'none',
    border: state.isFocused ? '1px solid #404ff5' : styles.border,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
  }),
  input: () => ({
    fontSize: '14px',
    height: '38px',
  }),
  placeholder: styles => ({ ...styles, fontSize: '14px' }),
  singleValue: (provided, state) => {
    const fontSize = '14px';

    return { ...provided, fontSize, };
  }
}

const NotificationItem = ({
  checkboxName,
  checkboxValue,
  setFormData,
  formData,
  defaultValue,
  handleSelect,
  selectOptions,
  isClearable,
  isMulti,
  isSearchable,
  wording,
  key,
  label,
  labelStyles,
  divStyles,
}) => {

  const addBotText = <FormattedMessage id="add.bot" defaultMessage="Please add the bot to the channel" />;

  return (
    <div className="w-100 flex align-start flex-column checkbox">
      <div className={`${!divStyles ? 'w-230px' : divStyles} checkbox-item active-status active-status-new flex align-center active-status ml-3`}>
        <input
          type="checkbox"
          id={checkboxName}
          name={checkboxName}
          checked={checkboxValue}
          value={checkboxValue}
          onChange={e => {
            setFormData({
              ...formData,
              [checkboxName]: !checkboxValue
            });
          }}
        />
        <label className={`fs-13 ${labelStyles ? labelStyles : ''}`} htmlFor={checkboxName}>{label}</label>
      </div>

      {checkboxValue && checkboxName !== 'emailIsActive' && (
        <div className="flex align-center  mt-1">
          <div className="w-350px">
            <SelectItem 
              defaultValue={defaultValue}
              onChange={handleSelect}
              options={selectOptions}
              customStyles={customStyles}
              isClearable={isClearable}
              key={key}
              wording={wording}
              isMulti={isMulti}
              isSearchable={isSearchable}
            />
          </div>
          {/* {checkboxName === 'slackIsActive' && <p className="fs-12 grey ml-3">{addBotText}</p>} */}
        </div>
      )}
    </div>
  );
};

NotificationItem.propTypes = {
  defaultValue: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func
};

export default NotificationItem;
